module.exports = __webpack_public_path__ + "static/img/gd1.c6cea92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/gd1.png
// module id = 297
// module chunks = 34